import type { ConversationMessage } from '@/features/AI-documents/types/docGen.types';
import type { ChatFlow, ChatFlowContext, ChatFlowEventResult } from './types';
import type { PreSetSelection } from '../types/preset.types';

/**
 * 기본 챗봇 플로우
 * 카테고리에 매칭되는 전용 플로우가 없을 때 사용
 * Task Title 입력 → 문서 확인 → Task 생성
 */
export const defaultFlow: ChatFlow = {
  id: 'default',
  categoryMatch: [],

  getInitialMessages(preSet: PreSetSelection): ConversationMessage[] {
    const docCount = preSet.documents.length;
    const categoryName = preSet.parentCategory?.CATEGORY_NAME || preSet.category.CATEGORY_NAME;

    return [
      {
        role: 'ai',
        content: `You selected **${preSet.task.TASK_NAME}** from ${categoryName}.\n\n` +
          (docCount > 0
            ? `This preset includes ${docCount} document(s). Please enter a Task Title to proceed.`
            : `Please enter a Task Title to proceed.`),
        timestamp: Date.now(),
        stepId: 1,
        source: 'system',
      },
    ];
  },

  steps: [
    {
      id: 'input-title',
      aiMessage: 'Please enter a Task Title.',
      widget: 'text-input',
      widgetConfig: {
        targetVarKey: '_taskTitle',
        targetEntityIndex: 0,
      },
      awaitEvent: true,
    },
    {
      id: 'confirm',
      aiMessage: 'Task is ready to be created. Click **Create Task** to proceed.',
      widget: null,
      nextStep: null,
    },
  ],

  handleEvent(eventName: string, payload: any, context: ChatFlowContext): ChatFlowEventResult {
    // Task Title 입력 처리
    if (eventName === 'value-submit' && context.currentStepId === 'input-title') {
      const title = typeof payload === 'string' ? payload : payload?.value || payload;
      return {
        messages: [
          {
            role: 'user',
            content: title,
            timestamp: Date.now(),
            stepId: 1,
          },
        ],
        formUpdates: { taskTitle: title },
        nextStepId: 'confirm',
      };
    }

    return {};
  },
};
